import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CommonService } from '@app/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class ReferralResolver  {
    constructor(
        private readonly _commonService: CommonService, 
        private readonly _router: Router
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
       
    const appData = this._commonService.appProfileDataAsValue;

    if (!appData?.currentOrganization?.referral_enabled) {
      this._router.navigate(
        [ route?.queryParams?.returnTo?.length ? route?.queryParams?.returnTo : '/home' ]
      );
      return false;
    }

    return true;

    }
}
